<template>
  <div>
    <div
      v-if="
        !visibleZbRating &&
        (!!reviewImage || !!reviewLink || !!Number(totalReview))
      "
      class="pt-1"
    >
      <p
        :hidden="hideTripadvisor"
        class="text-sm leading-5 text-black-100 fs-14 card-info-text"
      >
        Tripadvisor Traveler Rating
      </p>
      <div class="d-flex flex items-center">
        <img
          width="119"
          height="20"
          :src="reviewImage"
          :alt="title"
          class="review-image max-w-none"
        />
        <a
          target="_blank"
          :href="reviewLink"
          class="review-text underline text-underline text-black-light-5 text-sm leading-none"
        >
          <span>{{ totalReview }} reviews</span>
        </a>
      </div>
    </div>
    <div class="flex items-center pt-1" v-if="visibleZbRating">
      <rating
        v-if="rating.aggregated_rating"
        :value="rating.aggregated_rating.supplier_rating"
      />
      <span class="fs-14 font-medium text-black-light-5 ml-2">
        {{ rating.reviews_count }}
        {{ rating.reviews_count > 1 ? "reviews" : "review" }}
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Rating from "../core/Rating";

export default {
  components: {
    Rating,
  },
  props: [
    "supplierId",
    "price",
    "reviewImage",
    "reviewLink",
    "title",
    "totalReview",
    "hideTripadvisor",
  ],
  data() {
    return {
      rating: { aggregated_rating: null, reviews: [], reviews_count: 0 },
    };
  },
  computed: {
    visibleZbRating() {
      return (
        !!this.rating.aggregated_rating &&
        !!this.rating.aggregated_rating.supplier_rating
      );
    },
  },
  mounted() {
    const url = `${window.ZUBLU_VARIABLES.ODYSSEY_API}/api/v1/suppliers/${this.supplierId}/ratings`;

    axios
      .get(url)
      .then((response) => {
        this.rating = response.data;
      })
      .catch((err) => {})
      .finally(() => {});
  },
};
</script>
